import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useIsAdmin } from './hooks';
import { useAdminManagingCountry } from './useAdminManagingCountry';

import {
  getCategoryByCountryCodeOptions,
  IntlCategoriesDto,
} from '@/_generated/api-clients/content';

/** Categories. */
export const useCategories = <TData = IntlCategoriesDto>(
  select?: (data: IntlCategoriesDto) => TData,
): UseQueryResult<TData> => {
  const { selectedCountry } = useAdminManagingCountry();
  const isAdmin = useIsAdmin();

  return useQuery({
    ...getCategoryByCountryCodeOptions({
      query: {
        isAdmin,
        country: selectedCountry.label,
      },
    }),
    enabled: isAdmin,
    select,
  });
};
